<script lang="ts">
  import Loading from "../assets/images/loading.svg";

  export let title = "Submitting your entry.";
  export let subtitle = "Thank you for your patience.";
</script>

<main>
  <div class="container-center">
    <div
      class="w-full h-[calc(100vh-250px)] flex flex-col items-center justify-center text-center"
    >
      <img src={Loading} alt="loading" class="w-48 animate-spin" />

      <h2
        class="text-5xl text-black font-hilton-serif font-normal leading-120 mt-7"
      >
        {title}
      </h2>
      <p class="font-normal leading-120 mt-7">{subtitle}</p>
    </div>
  </div>
</main>
